"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var StarsIcon = function StarsIcon(props) {
  return _react["default"].createElement("svg", {
    "data-id": "icon-stars",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 171.13 32.09",
    width: props.width || "100px",
    height: props.height || "19px"
  }, _react["default"].createElement("title", null, "5 out of 5 star rating"), _react["default"].createElement("g", null, _react["default"].createElement("g", null, _react["default"].createElement("rect", {
    fill: "#00b67a",
    width: "32.09",
    height: "32.09"
  }), _react["default"].createElement("rect", {
    fill: "#00b67a",
    x: "34.76",
    width: "32.09",
    height: "32.09"
  }), _react["default"].createElement("rect", {
    fill: "#00b67a",
    x: "69.52",
    width: "32.09",
    height: "32.09"
  }), _react["default"].createElement("rect", {
    fill: "#00b67a",
    x: "104.28",
    width: "32.09",
    height: "32.09"
  }), _react["default"].createElement("rect", {
    fill: "#00b67a",
    x: "139.04",
    width: "32.09",
    height: "32.09"
  }), _react["default"].createElement("path", {
    fill: "#fff",
    d: "M16,21.62l4.88-1.23,2,6.28ZM27.27,13.5H18.68L16,5.41,13.4,13.5H4.81l7,5L9.12,26.6l7-5,4.27-3.07,6.92-5Z"
  }), _react["default"].createElement("path", {
    fill: "#fff",
    d: "M50.8,21.62l4.88-1.23,2,6.28ZM62,13.5H53.44L50.8,5.41,48.16,13.5H39.57l7,5L43.88,26.6l7-5,4.27-3.07,6.92-5Z"
  }), _react["default"].createElement("path", {
    fill: "#fff",
    d: "M85.56,21.62l4.88-1.23,2,6.28ZM96.79,13.5H88.2L85.56,5.41,82.92,13.5H74.33l7,5L78.64,26.6l7-5,4.27-3.07,6.92-5Z"
  }), _react["default"].createElement("path", {
    fill: "#fff",
    d: "M120.32,21.62l4.88-1.23,2,6.28Zm11.23-8.12H123l-2.64-8.09-2.64,8.09h-8.59l7,5L113.4,26.6l7-5,4.27-3.07,6.92-5Z"
  }), _react["default"].createElement("path", {
    fill: "#fff",
    d: "M155.08,21.62,160,20.39l2,6.28Zm11.23-8.12h-8.59l-2.64-8.09-2.64,8.09h-8.59l7,5-2.64,8.08,7-5,4.27-3.07,6.92-5Z"
  }))));
};

var _default = StarsIcon;
exports["default"] = _default;